export default "__VITE_ASSET__6ALmMfy9__"